import * as React from 'react'
import NavBar from '../../components/NavBar/NavBar'
import { History } from 'history'
import { Route, Switch, Redirect, RouteComponentProps } from 'react-router'
import { AddPhotos } from '../AddPhotos'
import { ModalStore, MODAL_STORE } from '../../stores/ModalStore'
import ProfilePage from '../Profile/ProfilePage'
import { UploadProgressSnackBar } from './components/UploadProgressSnackBar'
import AlbumsScreen from '../AlbumsScreen/AlbumsScreen'
import { AddAlbumPage } from '../AddAlbum/AddAlbumPage'
import { inject, Observer } from 'mobx-react'
import AlbumScreen from '../AlbumScreen/AlbumScreen'
import { WORKSPACES_STORE } from '../../stores'
import { WorkspacesStore } from '../../stores/WorkspaceStore'
import GalleryScreen from '../DisplayPhotos/GalleryScreen'
import { TimelinesScreen } from '../TimelinesScreen'
import { TimelineDetailScreen } from '../TimelineDetailScreen'
import { useEffect } from 'react'
import { Center } from '../../components/Common/Flex'
import { LoaderBlock } from '../../components/Spinner'

interface DashboardPageProps extends RouteComponentProps {
  history: History
  [MODAL_STORE]: ModalStore
  [WORKSPACES_STORE]: WorkspacesStore
}

const DashboardPage: React.FC<DashboardPageProps> = (props) => {
  const [loading, setLoading] = React.useState(true)

  useEffect(() => {
    ;(async () => {
      const pathname = props.location.pathname
      const parts = pathname.split('/')
      let currentSlugOrId: string | undefined
      if (parts.length >= 2 && parts[1]) {
        currentSlugOrId = parts[1]
      }
      const workspacesStore = props[WORKSPACES_STORE]

      if (workspacesStore.workspaces.length == 0) {
        await workspacesStore.fetch(currentSlugOrId)
      } else if (currentSlugOrId) {
        const workspace = workspacesStore.getWorkspaceBySlugOrId(currentSlugOrId)
        if (workspace && workspacesStore.activeWorkspaceId !== workspace.id) {
          workspacesStore.setActiveWorkspace(workspace)
        }
      }

      // Auto-redirect: if at root or workspace not found in URL, redirect to active workspace
      const activeSlug = workspacesStore.activeWorkspaceSlug
      if (activeSlug) {
        const isRoot = pathname === '/' || pathname === ''
        // If the URL used an ID instead of slug, redirect to canonical slug URL
        const usedId = currentSlugOrId && workspacesStore.getWorkspaceById(currentSlugOrId) && !workspacesStore.getWorkspaceBySlug(currentSlugOrId)

        if (isRoot) {
          props.history.replace(`/${activeSlug}`)
        } else if (usedId) {
          const rest = parts.slice(2).join('/')
          props.history.replace(`/${activeSlug}${rest ? '/' + rest : ''}`)
        }
      }

      setLoading(false)
    })()
  }, [props.location.pathname])

  if (loading) {
    return <LoaderBlock className="min-h-screen" />
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Observer>{() => <>{props[MODAL_STORE].modals}</>}</Observer>

      <UploadProgressSnackBar
        workspaceSlug={props[WORKSPACES_STORE].activeWorkspaceSlug}
        history={props.history}
      />
      <Route path="/" component={NavBar} />

      <main className="w-full">
        <Switch>
          <Route path="/:workspaceSlug/profile" component={ProfilePage} />
          <Route path="/:workspaceSlug/albums/add" component={AddAlbumPage} />
          <Route path="/:workspaceSlug/albums/:albumId" component={AlbumScreen} />
          <Route path="/:workspaceSlug/albums" component={AlbumsScreen} />
          <Route path="/:workspaceSlug/timelines/:timelineId" component={TimelineDetailScreen} />
          <Route path="/:workspaceSlug/timelines" component={TimelinesScreen} />
          {/* legacy search links redirect to the main gallery, which owns filters now */}
          <Route
            path="/:workspaceSlug/search"
            render={({ match, location }) => (
              <Redirect
                to={{ pathname: `/${match.params.workspaceSlug}`, search: location.search }}
              />
            )}
          />
          <Route path="/:workspaceSlug/upload" component={AddPhotos} />
          <Route path="/:workspaceSlug" component={GalleryScreen} />
        </Switch>
      </main>
    </div>
  )
}

export default inject(WORKSPACES_STORE)(inject(MODAL_STORE)(DashboardPage))
